import { Component } from '@angular/core';

import { RegisterComponent } from '../../components/component-lookup';

@RegisterComponent('ScoreLegend')
@Component({
  selector: 'app-score-legend',
  standalone: true,
  imports: [],
  templateUrl: './score-legend.component.html',
  styleUrl: './score-legend.component.scss'
})
export class ScoreLegendComponent {

}
